import { UserTicketCollapsedUpcomingPastFilteredInterface } from '../../..';
import { UserTicketCollapsedByEventAndOrderResponseDto } from './user-ticket-collapsed-by-event-and-order-response.dto';

export class UserTicketCollapsedUpcomingPastFilteredDto implements UserTicketCollapsedUpcomingPastFilteredInterface {
  upcoming?: UserTicketCollapsedByEventAndOrderResponseDto[];
  past?: UserTicketCollapsedByEventAndOrderResponseDto[];
}
